import { Box, Typography } from '@mui/material'
import { VerifiedIcon } from '../icons/VerifiedIcon'

const SippTooltip = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#005587',
        color: 'white',
        padding: '0.5rem',
        borderRadius: '0.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
        width: 'auto',
        minWidth: 155,
        position: 'relative',
        zIndex: 1000,

        '&::before': {
          content: '""',
          position: 'absolute',
          bottom: '-8px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '8px solid transparent',
          borderRight: '8px solid transparent',
          borderTop: '8px solid #005587',
          filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1))',
        }
      }}
    >
      {/* SIPP Logo */}
      <Box 
        component="img"
        src="/sipp-logo.svg" 
        alt="SIPP Logo"
        sx={{
          height: '18px',
          width: '22px',
          alignSelf: 'center'
        }}
      />

      {/* Protected by SIPP text with icon */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <VerifiedIcon 
          sx={{ 
            fontSize: '1rem',
            cursor: 'pointer'
          }}
          iconColor="white"
        />
        <Typography sx={{ fontSize: '0.75rem', fontWeight: 500 }}>
          PROTECTED BY SIPP
        </Typography>
      </Box>
    </Box>
  )
}

export default SippTooltip